/**
 * The tiers the public pricing page sells. Kept in step with the plan_tier
 * CHECK constraint on gyms and with GYM_PLAN_TIERS in the Worker.
 */
export const PLAN_TIERS = ['essentials', 'everything', 'custom'] as const
export type PlanTier = (typeof PLAN_TIERS)[number]

/** Tiers that include competitions, matching the pricing page. */
export function tierIncludesCompetitions(tier: PlanTier): boolean {
  return tier === 'everything' || tier === 'custom'
}
